import React from 'react';
import { useAuth } from '../../auth/AuthProvider';
import YonetimDashboard from './YonetimDashboard';
import SatinalmaDashboard from './SatinalmaDashboard';
import UretimDashboard from './UretimDashboard';
import MuhasebeDashboard from './MuhasebeDashboard';
import DepoDashboard from './DepoDashboard';
import SubeDashboard from './SubeDashboard';
import OperasyonDashboard from './OperasyonDashboard';
import IkDashboard from './IkDashboard';

const DashboardRouter = () => {
  const { user } = useAuth();
  switch (user?.role) {
    case 'admin': case 'yonetim': return <YonetimDashboard />;
    case 'satinalma': return <SatinalmaDashboard />;
    case 'üretim': return <UretimDashboard />;
    case 'muhasebe': return <MuhasebeDashboard />;
    case 'depo': return <DepoDashboard />;
    case 'sube': return <SubeDashboard />;
    case 'operasyon': return <OperasyonDashboard />;
    case 'ik': return <IkDashboard />;
    default: return <YonetimDashboard />;
  }
};

export default DashboardRouter;
